module.exports = __webpack_public_path__ + "static/media/calendar.a7242d7c.svg";